<script>
import Vue from "vue";
import simplebar from "simplebar-vue";
import DatePicker from "vue2-datepicker";
import axios from "axios";
import Swal from "sweetalert2";
export default {
  components: {
    simplebar,
    DatePicker
  },
  data() {
    return {
      loader: false,
      curr: {},
      leaveExpandModal: false,
      leaveModalApplnLoader: false,
      approveLeaveData: {},
      approveModal: false,
      rejectModal: false,
      approveLeaveError: false,
      rejectLeaveData: {},
      leaveApplnLoader: false,
      leaveData: [
      ],
      leaveApplnModalDateRange: [],
      leaveModalData: [],
      selectedCalYear: '',
      yearSeries: [],
      defaultLeaveChartData: {
        series: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      },
      leaveChart: {
        series: [{
            name: 'Approved Leaves',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        }],
        chartOptions: {
            chart: {
                toolbar: {
                    show: false,
                }
            },
            plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '14%',
                endingShape: 'rounded'
                },
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                show: true,
                width: 2,
                colors: ['transparent']
            },
            xaxis: {
                categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            },
            yaxis: {
                title: {
                    text: 'No Of Leaves'
                }
            },
            fill: {
                opacity: 1

            },
            colors: ['#556ee6'],
        }
      },
      monthDays: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
      donutChart: {
        series: [100],
        chartOptions: {
            labels: ["N.A",],
            dataLabels: {
              enabled: true,
              formatter: function (val, opts) {
                  return opts.w.config.series[opts.seriesIndex]
              },
            },
            colors: ["#34c38f", "#556ee6", "#f46a6a", "#50a5f1", "#f1b44c", "#34a9c3", "#e85fa8", "#e8a65f", "#5fe8df" , "#e8e85f"],
            legend: {
                show: true,
                position: 'left',
                horizontalAlign: 'left',
                verticalAlign: 'middle',
                floating: false,
                fontSize: '10px',
                offsetX: 0
            },
            responsive: [{
                breakpoint: 600,
                options: {
                    chart: {
                        height: 240
                    },
                    legend: {
                        show: false
                    },
                }
            }]
        }
      }
    };
  },
  props: ['dataProp'],
  created() {
    this.curr = this.dataProp;

    this.loginData = JSON.parse(localStorage.getItem('user'));
    //this.getLeaveAppln();

    let today = new Date();
    today.setHours(0, 0, 0, 0);

    let dateVal = today.getDate();

    let monthDay = this.monthDays[today.getMonth()];
    if(today.getMonth() == 1 && this.checkLeapYear(today.getFullYear())) {
      monthDay = 29;
    }

    let thisMonthFirstDate = new Date();
    thisMonthFirstDate.setDate(today.getDate() - dateVal + 1);
    thisMonthFirstDate.setHours(0, 0, 0, 0);

    let thisMonthLastDate = new Date();
    thisMonthLastDate.setDate(monthDay);
    thisMonthLastDate.setHours(0, 0, 0, 0);

    this.leaveApplnModalDateRange.push(thisMonthFirstDate);
    this.leaveApplnModalDateRange.push(thisMonthLastDate);
  },
  methods: {
    openLeaveExpandModal() {
      this.getModalLeaveAppln();
      this.getLeaveInsightsGraph();
      this.leaveExpandModal = true;
    },
    openApproveModal(val) {
      this.approveLeaveError = false;
      this.approveLeaveData = JSON.parse(JSON.stringify(val));
      this.approveLeaveData.approvedFromTime = new Date(this.approveLeaveData.reqFromTime);
      this.approveLeaveData.approvedToTime = new Date(this.approveLeaveData.reqToTime);
      this.approveLeaveData.appFromType = this.approveLeaveData.reqFromType == 0 ? true : false;
      this.approveLeaveData.appToType = this.approveLeaveData.reqToType == 0 ? true : false;

      this.approveModal = true;
    },
    openLeaveRejectModal(val) {
      this.rejectLeaveData.empId = val.empId;
      this.rejectLeaveData.leaveId = val.id;
      this.rejectModal = true;
    },
    rejectLeave() {
      let formData = new FormData();

      formData.append("companyId", this.loginData.companyId);
      formData.append("leaveId", this.rejectLeaveData.leaveId);
      formData.append("empId", this.rejectLeaveData.empId);
      formData.append("rejectLid", this.loginData.lid);
      formData.append("comments", this.rejectLeaveData.comments);

      axios
          .post(`https://workrhythm.net:8090/employee/reject_leave`, formData)
          .then((res) => {
            if(res.data.success == "true") {
              Swal.fire({
                title: "Added!",
                text: "Leave has been rejected.",
                icon: 'success',
                onClose: () => {
                 this.getModalLeaveAppln();
                 this.rejectModal = false;
                }
              });
            } else {
              Vue.swal(res.data);
            }
            return res;
          })
          .catch((err) => {
            Vue.swal("Oops! Some error occured.");
            return err;
          });
    },
    approveLeave() {
      if(this.approveLeaveData.approvedFromTime == null || this.approveLeaveData.approvedFromTime == '') {
        this.approveLeaveError = true;
        return;
      }

      if(this.approveLeaveData.approvedToTime == null || this.approveLeaveData.approvedToTime == '') {
         this.approveLeaveError = true;
        return;
      }
       this.approveLeaveError = false;
      let appFromType = this.approveLeaveData.appFromType == true ? 0 : 2;
      let appToType = this.approveLeaveData.appToType == true ? 0 : 1;
      var date = new Date(this.approveLeaveData.approvedFromTime),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);

      let from = [date.getFullYear(), mnth, day].join("-");

      date = new Date(this.approveLeaveData.approvedToTime),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);

      let to = [date.getFullYear(), mnth, day].join("-");
      let formData = new FormData();

      formData.append("companyId", this.loginData.companyId);
      formData.append("empId", this.approveLeaveData.empId);
      formData.append("leaveId", this.approveLeaveData.id);
      formData.append("approveLid", this.loginData.lid);
      formData.append("appFromType", appFromType);
      formData.append("from", from);
      formData.append("appToType", appToType);
      formData.append("to", to);
      formData.append("comments", this.approveLeaveData.comments);

      axios
          .post(`https://workrhythm.net:8090/employee/approve_leave`, formData)
          .then((res) => {
            if(res.data.success == "true") {
              Swal.fire({
                title: "Added!",
                text: "Leave has been Approved.",
                icon: 'success',
                onClose: () => {
                 this.getModalLeaveAppln();
                 this.approveModal = false;
                }
              });
            } else {
              Vue.swal(res.data);
            }
            return res;
          })
          .catch((err) => {
            Vue.swal("Oops! Some error occured.");
            return err;
          });
    },
    checkLeapYear(year) {
      let leap = false;

      if (year % 4 == 0) {
        if (year % 100 == 0) {
          if (year % 400 == 0) {
            leap = true;
          } else {
            leap = false;
          }
        } else {
          leap = true;
        }
      } else {
        leap = false;
      }
      return leap;
    },
    async getLeaveAppln() {
      this.leaveApplnLoader = true;
      this.leaveData = [];
      try {
        const response = await axios.get(`https://workrhythm.net:8090/employee/leave_appln`,{
          params: { companyId: this.loginData.companyId, empId: this.curr.empId},
        }
        );
        
        if(response.data.success == "true") {
          this.leaveData = response.data.data;
        }
      } catch (error) {
        this.leaveApplnLoader = false;
      }
      this.leaveApplnLoader = false;
    },
    async getModalLeaveAppln() {
      
      var date = new Date( this.leaveApplnModalDateRange[0]),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      let startDate = [date.getFullYear(), mnth, day].join("-");

      date = new Date( this.leaveApplnModalDateRange[1]),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
       let endDate = [date.getFullYear(), mnth, day].join("-");

      this.leaveModalApplnLoader = true;
      this.leaveModalData = [];
      try {
        const response = await axios.get(`https://workrhythm.net:8090/employee/leave_appln`,{
          params: { companyId: this.loginData.companyId, empId: this.curr.empId, startDate: startDate, endDate: endDate },
        }
        );

        if(response.data.success == "true") {
          this.leaveModalData = response.data.data;
        }
      } catch (error) {
        this.leaveModalApplnLoader = false;
      }
      this.leaveModalApplnLoader = false;
    },
    async getLeaveInsightsGraph() {
      let startCyear = '';
      let endCYear = '';

      //2022-4,2022-3
      if(this.selectedCalYear != null && this.selectedCalYear != '') {
        let splits = this.selectedCalYear.split(',');
        startCyear = splits[0];
        endCYear = splits[1];
      }

      this.leaveChart.series[0].data = this.defaultLeaveChartData.series;
      this.leaveChart.chartOptions.xaxis.categories = this.defaultLeaveChartData.categories;
      try {
        const response = await axios.get(`https://workrhythm.net:8090/employee/leave_insights_graph`,{
          params: { companyId: this.loginData.companyId, empId: this.curr.empId, startCyear: startCyear, endCYear: endCYear},
        }
        );

        if(response.data.success == "true") {
          this.yearSeries = response.data.data.yearSeries;

          if(this.selectedCalYear == '') {
            this.selectedCalYear = this.yearSeries[this.yearSeries.length - 1].val;
            for(var i = 0;i < this.yearSeries.length;i++) {
              if( this.yearSeries[i].curr == true) {
                 this.selectedCalYear = this.yearSeries[i].val;
                 break;
              }
            }
          }
          

          for(i = 0;i < response.data.data.leavesTakenSeries.length;i++) {
            this.donutChart.series[i] = response.data.data.leavesTakenSeries[i].leavesTaken;
            this.donutChart.chartOptions.labels[i] = response.data.data.leavesTakenSeries[i].leaveName;
          }

          for(i = 0;i < response.data.data.leaveGraph.length;i++) {
            this.leaveChart.series[0].data[i] = response.data.data.leaveGraph[i].leaves;
            this.leaveChart.chartOptions.xaxis.categories[i] = response.data.data.leaveGraph[i].month;
          }
          window.dispatchEvent(new Event('resize'));
        }
      } catch (error) {
        //log
      }
    },
    downloadLeaveAppln() {
      var fields = ["reqFromType", "reqFromTime", "reqToType", "reqToTime", "leaveName", "leaveReason", "status", "appFromType", "approvedFromTime", "appToType", "approvedToTime", "comments"];
      let fileName = "leaveAppln.csv";
      this.convertToCSV(this.leaveModalData, fields, fileName);
    },
    toSnakeCase(inputString) {
      return inputString.split('').map((character) => {
          if (character == character.toUpperCase()) {
              return ' ' + character;
          } else {
              return character;
          }
      })
      .join('');
    },
    async convertToCSV(data, fields, fileName) {
      const json = data;
      //var fields = Object.keys(json[0])
      //var fields = ["name", "email", "designation", "teamName", "activeHours", "idleHours", "productivity"];
      var replacer = function(key, value) { return value === null ? '' : value } 
      var csv = json.map(function(row){
        return fields.map(function(fieldName){
          let data = row[fieldName];
          if(fieldName == 'date') {
            let calMonths = ["January", "February", "March","April", "May","June", "July","August", "September","October", "November", "December"];
            let d = new Date(data),
              mnth = ("0" + (d.getMonth() + 1)).slice(-2),
              day = ("0" + d.getDate()).slice(-2);

            data = day + ' ' + calMonths[parseInt(mnth) - 1] + ' ' + d.getFullYear();
          } else if(fieldName == 'reqFromType') {
            if(data == 2) {
              data = "2nd HALF";
            } else {
              data = "FULL DAY";
            }
          } else if(fieldName == 'reqToType') {
            if(data == 1) {
              data = "1st HALF";
            } else {
              data = "FULL DAY";
            }
          } else if(fieldName == 'appFromType') {
            if(data == 2) {
              data = "2nd HALF";
            } else {
              data = "FULL DAY";
            }
          } else if(fieldName == 'appToType') {
            if(data == 1) {
              data = "1st HALF";
            } else {
              data = "FULL DAY";
            }
          } else if(fieldName == 'status') {
            if(data == 0) {
              data = "PENDING";
            } else if(data == 1) {
              data = "APPROVED";
            } else if(data == 2) {
              data = "REJECTED";
            }
          }
          return JSON.stringify(data, replacer)
        }).join(',')
      })

      // Name, Email, Designation, Team Name, Active Hours, Idle Hours, Productivity
      for(var i = 0;i < fields.length;i++) {
        if(fields[i] == 'reqFromType') {
          fields[i] = 'Requested From Type';
        } else if(fields[i] == 'reqToType') {
          fields[i] = 'Requested To Type';
        } else if(fields[i] == 'appFromType') {
          fields[i] = 'Approved From Type';
        } else if(fields[i] == 'appToType') {
          fields[i] = 'Approved To Type';
        } else if(fields[i] == 'reqFromTime') {
          fields[i] = 'Requested From';
        } else if(fields[i] == 'reqToTime') {
          fields[i] = 'Requested To';
        } else if(fields[i] == 'approvedFromTime') {
          fields[i] = 'Approved From';
        } else if(fields[i] == 'approvedToTime') {
          fields[i] = 'Approved To';
        } else {
          fields[i] = this.toSnakeCase(fields[i]);
          fields[i] = fields[i].charAt(0).toUpperCase() + fields[i].slice(1);
        }
      }
      csv.unshift(fields.join(',')) // add header column
      csv = csv.join('\r\n');

      //console.log(csv);
      var exportedFilenmae = fileName;
      var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      if (navigator.msSaveBlob) { // IE 10+
          navigator.msSaveBlob(blob, exportedFilenmae);
      } else {
          var link = document.createElement("a");
          if (link.download !== undefined) { // feature detection
              // Browsers that support HTML5 download attribute
              var url = URL.createObjectURL(blob);
              link.setAttribute("href", url);
              link.setAttribute("download", exportedFilenmae);
              link.style.visibility = 'hidden';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
          }
      }
    },
  },
  
};
</script>

<template>
  <div class="card">
    <div class="card-body" style="height: calc(100vh - 282px);">
      <div class="is-loading">
        <div class="preloader-component" v-show="leaveApplnLoader">
          <div class="status">
            <div class="spinner-chase">
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
            </div>
          </div>
        </div>
        <div class="d-flex">
          <div class="mb-4">
            <h5 class="card-title">{{ $t('menuitems.attendance.leaveDetails') }} </h5> 
            
          </div>
          <!--<button type="button" @click="openLeaveExpandModal" class="btn btn-link ms-auto font-size-8 p-0 mb-4">{{ $t('menuitems.attendance.viewDetails') }} <i class="bx bx-expand"></i></button>-->
          <!--<b-dropdown
          text="Button text via Prop"
          toggle-tag="a"
          toggle-class="text-muted font-size-16 p-0"
          variant="white"
          menu-class="dropdown-menu-end"
          right
          class="ms-auto"
        >
          <template #button-content>
            <i class="mdi mdi-dots-horizontal"></i>
          </template>
          <b-dropdown-item href="#">Action</b-dropdown-item>
          <b-dropdown-item href="#">Another action</b-dropdown-item>
          <b-dropdown-item href="#">Something else here</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item href="#">Separated link</b-dropdown-item>
        </b-dropdown>-->
        </div>
         <div v-if="leaveData.length > 0">
          <ul class="verti-timeline list-unstyled">
            <simplebar
                style="max-height: calc(100vh - 386px); padding-left: 10px"
                ref="current"
                id="containerElement"
              >

              <li class="event-list" v-for="(val, index) in leaveData" :key="index">
                <div class="event-timeline-dot text-primary">
                  <i v-if="index == 0" class="bx bx-right-arrow-circle bx-fade-right"></i>
                  <i v-else class="bx bx-right-arrow-circle"></i>
                </div>
                <div class="d-flex">
                  <div class="flex-grow-1">
                    <div>
                      <h6 class="font-size-13">
                        <a href="javascript: void(0);" class="text-dark"
                          ><span>{{ $t('menuitems.attendance.from') }} <span v-if="val.reqFromType == 2">{{ $t('menuitems.attendance.secondHalfOf') }} </span>{{ val.reqFromTime }}</span><span> {{ $t('menuitems.attendance.to') }} <span  v-if="val.reqToType == 1">{{ $t('menuitems.attendance.firstHalfOf') }} </span>{{ val.reqToTime }}</span></a
                        > <span class="badge badge-soft-info font-size-8" v-if="val.status == 0">{{ $t('menuitems.attendance.pending') }}</span>
                        <span class="badge badge-soft-success font-size-8" v-if="val.status == 1">{{ $t('menuitems.attendance.approved') }}</span>
                        <span class="badge badge-soft-danger font-size-8" v-if="val.status == 2">{{ $t('menuitems.attendance.rejected') }}</span>
                      </h6>
                      <span class="text-secodary"
                        >{{ $t('menuitems.attendance.applied') }} {{ val.leaveName }} {{ $t('menuitems.attendance.for') }} {{ val.leaveReason }}.
                      </span>
                    </div>
                  </div>
                </div>
              </li>
            </simplebar>
            </ul>
        </div>
        <div v-if="leaveData.length <= 0" style="margin-top: 47%;margin-left: 28%;">
          <img src="@/assets/images/no-data.png" alt="No Data"  height="120" width="120"><br />
          <span class="mt-2 text-secondary fw-bold fs-4">{{ $t('menuitems.attendance.noLeaveFound') }}</span>
        </div>
      </div>
    </div>
    <b-modal v-model="leaveExpandModal" size="xl" centered :title="$t('menuitems.attendance.leaveInsights')" hide-footer>
        <div class="row">
          <div class="col-md-9">
            </div>
            <div class="col-md-3">
              <b-form-select
                        class="form-select mb-3"
                        v-model="selectedCalYear"
                        @change="getLeaveInsightsGraph"
                      >
                  <b-form-select-option v-for="val in yearSeries" :key="val.val" :value="val.val" 
                    >{{ val.year }}</b-form-select-option
                  >
                    </b-form-select>
            </div>
        </div>
        <div class="row">
          <div class="col-md-5">
            <h4 class="ms-4">{{ $t('menuitems.attendance.leavesTaken') }}</h4>
            <apexchart
                class="apex-charts"
                height="220"
                type="donut"
                dir="ltr"
                :series="donutChart.series"
                :options="donutChart.chartOptions"
              ></apexchart>
          </div>
          <div class="col-md-7">
            <h4 class="ms-4">{{ $t('menuitems.attendance.approvedLeaves') }}s</h4>
            <apexchart
              class="apex-charts"
              type="bar"
              height="220"
              :series="leaveChart.series"
              :options="leaveChart.chartOptions"
            ></apexchart>
          </div>
        </div>
        <div class="row mb-2 mt-2">
          <div class="col-md-8">
            <h4>{{ $t('menuitems.attendance.leaveDetails') }}</h4>
          </div>
          <div class="col-md-3 text-end">
            <date-picker range append-to-body lang="en" confirm v-model="leaveApplnModalDateRange" @change="getModalLeaveAppln"></date-picker>
          </div>
          <div class="col-md-1">
            <button class="btn btn-outline-primary" @click="downloadLeaveAppln"><i class="bx bx-download"></i></button>
          </div>
        </div>
        <div class="is-loading">
            <div class="preloader-component" v-show="leaveModalApplnLoader" style="top: 10%;">
              <div class="status">
                <div class="spinner-chase">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
        <!--<simplebar style="height: calc(100vh - 548px);overflow-x: hidden;" >-->
            <div v-if="leaveModalData.length > 0" class="table-responsive table-hover">
            <table class="table table-fixed" >
              <thead class="table-light">
                <tr>
                  <th scope="col">{{ $t('menuitems.attendance.from') }} - {{ $t('menuitems.attendance.To') }}</th>
                  <th scope="col">{{ $t('menuitems.attendance.reason') }}</th>
                  <th scope="col">{{ $t('menuitems.attendance.leaveType') }}e</th>
                  <th scope="col">{{ $t('menuitems.attendance.status') }}</th>
                  <th scope="col">{{ $t('menuitems.attendance.action') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(val, index) in leaveModalData" :key="index">
                  <td class="fw-bold">
                    <span>{{ $t('menuitems.attendance.from') }} <span v-if="val.reqFromType == 2">{{ $t('menuitems.attendance.secondHalfOf') }} </span>{{ val.reqFromTime }}</span><span> {{ $t('menuitems.attendance.to') }} <span  v-if="val.reqToType == 1">{{ $t('menuitems.attendance.firstHalfOf') }} </span>{{ val.reqToTime }}</span>
                  </td>
                  <td>
                    {{ val.leaveName }}
                  </td>
                  <td>
                    {{ val.leaveReason }}.
                  </td>
                  <td>
                    <span class="badge badge-soft-info font-size-8" v-if="val.status == 0">{{ $t('menuitems.attendance.pending') }}</span>
                    <span class="badge badge-soft-success font-size-8" v-if="val.status == 1">{{ $t('menuitems.attendance.approved') }}</span>
                    <span class="badge badge-soft-danger font-size-8" v-if="val.status == 2">{{ $t('menuitems.attendance.rejected') }}</span>
                  </td>
                  <td>
                    <button class="btn btn-outline-success btn-sm me-2" @click="openApproveModal(val)" :disabled="val.status == 1">{{ $t('menuitems.attendance.approve') }}</button><button class="btn btn-outline-danger btn-sm" @click="openLeaveRejectModal(val)" :disabled="val.status == 2">{{ $t('menuitems.attendance.reject') }}</button>
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
            <div v-if="leaveModalData.length <= 0" style="margin-top: 8%;margin-left: 40%;margin-bottom: 8%;">
              <img src="@/assets/images/no-data.png" alt="No Data"  height="120" width="120"><br />
              <span class="mt-2 text-secondary fw-bold fs-4">{{ $t('menuitems.attendance.noLeaveFound') }}</span>
            </div>
        </div>
      <!--</simplebar>-->
    </b-modal>

    <b-modal v-model="approveModal" size="md" centered :title="$t('menuitems.attendance.approveLeave')" hide-footer>
    <div class="col-12">
        <div class="row mb-4">
          <div class="col-md-3">
            {{ $t('menuitems.attendance.leaveType') }} : 
          </div>
          <div class="col-md-4">
            <span class="fw-bold">{{ approveLeaveData.leaveName }}</span>
            </div>

        </div>
        <div class="row mb-3">
          <div class="col-md-3" :class="{
              'text-danger': approveLeaveError,
            }">
            {{ $t('menuitems.attendance.from') }} : 
          </div>
          <div class="col-md-6">
            <date-picker v-model="approveLeaveData.approvedFromTime" :first-day-of-week="1" lang="en" :placeholder="$t('menuitems.reports.selectDate')"></date-picker>
          </div>
          <div class="col-md-3">
              <b-form-checkbox
              class="mb-3"
              checked
              v-model="approveLeaveData.appFromType"
              plain
              >{{ $t('menuitems.attendance.fullDay') }}</b-form-checkbox
            >
           </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-3" :class="{
              'text-danger': approveLeaveError,
            }">
            {{ $t('menuitems.attendance.To') }} : 
          </div>
          <div class="col-md-6">
            <date-picker v-model="approveLeaveData.approvedToTime" :first-day-of-week="1" lang="en" :placeholder="$t('menuitems.reports.selectDate')"></date-picker>
          </div>
          <div class="col-md-3">
              <b-form-checkbox
              class="mb-3"
              checked
              plain
              v-model="approveLeaveData.appToType"
              >{{ $t('menuitems.attendance.fullDay') }}</b-form-checkbox
            >
           </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-3">
            {{ $t('menuitems.attendance.comments') }} : 
          </div>
          <div class="col-md-8">
            <textarea
              name="description"
              class="form-control"
            ></textarea>
            </div>

        </div>
        <div class="text-end mt-3">
        <b-button variant="light" @click="leaveActionModal = false">{{ $t('menuitems.attendance.close') }}</b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="approveLeave"
          >{{ $t('menuitems.attendance.approve') }}</b-button
        >
      </div>
      </div>
    </b-modal>

    <b-modal v-model="rejectModal" size="md" centered :title="$t('menuitems.attendance.rejectLeave')" hide-footer>
    <div class="col-12">
        <div class="row mb-3">
          <div class="col-md-4">
            {{ $t('menuitems.attendance.comments') }} : 
          </div>
          <div class="col-md-8">
            <textarea
              name="description"
              class="form-control"
              v-model="rejectLeaveData.comments"
            ></textarea>
            </div>

        </div>
        <div class="text-end mt-3">
        <b-button variant="light" @click="leaveActionModal = false"> {{ $t('menuitems.attendance.close') }}</b-button>
        <b-button type="submit" variant="danger" class="ms-1" @click="rejectLeave"
          > {{ $t('menuitems.attendance.reject') }}</b-button
        >
      </div>
      </div>
    </b-modal>
  </div>
  
  

</template>

<style scoped>
table {
        table-layout:fixed;
    }
.is-loading {
  position: relative;
}
.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 999;
  width: 100%;
}
.status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
tbody {
    display:block;
    height: calc(100vh - 600px);
    overflow:auto;
}
thead, tbody tr {
    display:table;
    width:100%;
    table-layout:fixed;
}
</style>